import { getSupabase } from "@/lib/supabase";
import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";

export function useIsContractor() {
  const { user } = useAuth();
  // Key the effect on the id (a stable primitive), not the user object - a
  // token refresh on tab focus mints a new user object with the same id, and
  // depending on the object would re-run this effect, flip `loading`, and
  // remount the ContractorRoute subtree (wiping any in-progress form).
  const userId = user?.id ?? null;
  const [isContractor, setIsContractor] = useState(false);
  const [contractorId, setContractorId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setIsContractor(false);
      setContractorId(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    (async () => {
      const sb = getSupabase();
      const { data } = await sb.rpc("is_contractor");
      if (cancelled) return;
      const flag = data === true;
      setIsContractor(flag);
      if (flag) {
        const { data: row } = await sb
          .from("contractors")
          .select("id")
          .eq("user_id", userId)
          .maybeSingle();
        if (!cancelled) setContractorId((row as { id: string } | null)?.id ?? null);
      } else {
        setContractorId(null);
      }
      if (!cancelled) setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { isContractor, contractorId, loading };
}
